module.exports = __webpack_public_path__ + "img/skull_12_bj.6c0dc045.png";